import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthoringStore } from "../../store/UseAuthorStore";
import { useManualAuthoringStore } from "../../store/manualAuthoringStore";

export default function ManualAuthoringHeaderReviewer() {
  const navigate = useNavigate();
  const manual = useManualAuthoringStore((s) => s.presentManual);
  const manualTitle = useManualAuthoringStore((s) => s.manualTitle);
  const selectedSectionId = useManualAuthoringStore((s) => s.selectedSectionId);
  const selectedSubSectionId = useManualAuthoringStore(
    (s) => s.selectedSubSectionId
  );
  const partNumber = useAuthoringStore((s) => s.partNumber);

  const activeSection = useMemo(
    () => manual.sections.find((s) => s.id === selectedSectionId),
    [manual.sections, selectedSectionId]
  );

  const activeSubSection = useMemo(
    () => activeSection?.subSections?.find((s) => s.id === selectedSubSectionId),
    [activeSection, selectedSubSectionId]
  );

  const manualName = manualTitle || "Manual";

  return (
    <div className="manual-authoring-header px-4 py-2 border-bottom bg-light d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center flex-wrap small">
        <span className="fw-semibold text-dark">Part Number: {partNumber || "-"}</span>

        <span className="mx-3 text-secondary">•</span>

        <span className="text-muted">Manual: {manualName}</span>

        {activeSection ? (
          <>
            <span className="mx-3 text-secondary">•</span>
            <span className="text-muted">Section: {activeSection.title}</span>
          </>
        ) : null}

        {activeSubSection ? (
          <>
            <span className="mx-3 text-secondary">•</span>
            <span className="text-muted">Subsection: {activeSubSection.title}</span>
          </>
        ) : null}
      </div>

      <div className="d-flex align-items-center gap-2">
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
      </div>
    </div>
  );
}
